import api from './api';

export const providerService = {
  // Obtener todos los proveedores con paginación y filtros
  async getProviders(params = {}) {
    try {
      const response = await api.get('/api/providers', { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener proveedores',
      };
    }
  },

  // Obtener un proveedor por ID
  async getProvider(id) {
    try {
      const response = await api.get(`/api/providers/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener proveedor',
      };
    }
  },

  // Crear nuevo proveedor
  async createProvider(providerData) {
    try {
      const response = await api.post('/api/providers', providerData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear proveedor',
      };
    }
  },

  // Actualizar proveedor
  async updateProvider(id, providerData) {
    try {
      const response = await api.put(`/api/providers/${id}`, providerData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar proveedor',
      };
    }
  },

  // Eliminar proveedor
  async deleteProvider(id) {
    try {
      const response = await api.delete(`/api/providers/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar proveedor',
      };
    }
  },

  // Añadir contacto a proveedor
  async addContact(providerId, contactData) {
    try {
      const response = await api.post(`/api/providers/${providerId}/contacts`, contactData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al añadir contacto',
      };
    }
  },

  // Eliminar contacto
  async deleteContact(contactId) {
    try {
      const response = await api.delete(`/api/providers/contacts/${contactId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar contacto',
      };
    }
  },

  // Añadir cuenta bancaria a proveedor
  async addAccount(providerId, accountData) {
    try {
      const response = await api.post(`/api/providers/${providerId}/accounts`, accountData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al añadir cuenta',
      };
    }
  },

  // Eliminar cuenta bancaria
  async deleteAccount(accountId) {
    try {
      const response = await api.delete(`/api/providers/accounts/${accountId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar cuenta',
      };
    }
  },
}; 